// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__jEIyZ","without_margin":"Loader_without_margin__t1d8D","app_loader":"Loader_app_loader__9kgMl"};